import React, { useState, useEffect } from 'react';
import NavigationBar from '../navbar/NavigationBar';
import DownloadIcon from '@mui/icons-material/Download';
import {
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    Divider,
    FormControl,
    Select,
    MenuItem,
    Tabs,
    Tab,
} from '@mui/material';
import Footer from '../navbar/Footer';

const annuaires = [
    {
        title: "Étude d'impact de la pandémie du COVID-19 sur les entreprises et les conditions de vie des ménages au Burundi (2020)",
        link: "/documents/EnquenteSanteDemographes/ETUDE-1.pdf",
        description: "16% des ménages burundais ont connu la faim, 70% une baisse de revenus, et 64% des entreprises une chute des ventes pendant la COVID-19.",
        date: "2020-10-01",
    },
    {
        title: "Enquête de structure des établissements sanitaires et éducatifs privés - Rapport",
        link: "/documents/EnquenteSanteDemographes/RAPPORT-DENQUETE-AUPRES-DES-STRUCTURES-PRIVEES_SANTE_EDUCATION-vF.pdf",
        description: "Les structures privées d'éducation et de santé ont généré plus de 90 milliards FBU de chiffre d'affaires combiné en 2017, révélant une croissance significative malgré des défis de gestion des stocks.",
        date: "2019-08-15",
    },
    
    {
        title: "Enquête de base sur l'intégration de la santé mentale dans les services de santé primaire",
        link: "/documents/EnquenteSanteDemographes/Rapport-Definitif-Enquete-de-Base-Sante-Mentale.pdf",
        description: "L'enquête nationale sur la santé mentale : 42,7% des Burundais déclarent des troubles psychologiques, avec 64,5% en détresse. 8,3% ont envisagé le suicide et 33,4% présentent un stress post-traumatique.",
        date: "2019-11-10",
    },
    
    {
        title: "Enquête de couverture vaccinale post-campagne contre la méningite",
        link: "/documents/EnquenteSanteDemographes/ENQUETE-MENINGITE_RAPPORT-DEFINITIF.24.10.2019.pdf",
        description: "L'enquête nationale révèle un taux de couverture vaccinale de 98% contre la méningite A, avec 35 219 personnes interrogées, une faible prévalence d'effets secondaires (0,8%) et une bonne connaissance de la maladie (87,1%).",
        date: "2018-10-01",
    },
    
    {
        title: "Enquête indépendantes sur la couverture post-campagne de vaccination anti-rougeoleuse",
        link: "/documents/EnquenteSanteDemographes/Rapport_RR_final_Version-du-30012019-1.pdf",
        description: "L'enquête post-campagne de vaccination anti-rougeoleuse et anti-rubéoleuse de 2017 a révélé un taux de couverture vaccinale de 95,7% au Burundi, avec 20 746 enfants enquêtés et une légère prédominance féminine (50,7%).",
        date: "2018-10-01",
    },
    {
        title: "Enquête de couverture vaccinale contre le HPV",
        link: "/documents/EnquenteSanteDemographes/Rapport_HPV_final_version-du-30012019-1-1.pdf",
        description: "L’enquête a révélé un taux de couverture vaccinale de 93,3% pour la 1ère dose (décembre 2016) et 84,9% pour la 2ème dose (juin 2017) du vaccin anti-HPV, avec une participation de 98,1% des ménages et des effets secondaires mineurs (2,7% en 2016, 2,3% en 2017).",
        date: "2018-10-01",
    },
    
    {
        title: "Évaluation des besoins en soins obstétricaux et néonataux d’urgence au Burundi",
        link: "/documents/EnquenteSanteDemographes/Enquete-SONU_Rapport-Defintif.pdf",
        description: "L'enquête SONU révèle que le Burundi compte seulement 22 formations sanitaires SONU (17 SONUC et 5 SONUB) sur 274 enquêtées, avec des lacunes critiques en personnel qualifié, équipements et médicaments essentiels, notamment pour la prise en charge des urgences obstétricales.",
        date: "2011-03-01",
    }

];

const odd = [
    {
        title: "Analyse secondaire des données de l’enquête démographique et de santé du Burundi (EDS 2016-2017) - Rapport final",
        link: "/documents/EnquenteSanteDemographes/EDSB_Rapport-consolide_Analyse-Secondaire-.pdf",
        description: "Le Burundi enregistre une baisse de la mortalité maternelle (392 décès/100.000 naissances), mais des défis persistent : 15% des accouchements sans assistance qualifiée et seulement 48% de CPN précoces, avec des disparités liées à l'éducation, au milieu rural et à la couverture santé.",
        date: "2019-01-01"
    },
    {
        title: "Analyse secondaire des données de l’enquête démographique et de santé du Burundi (EDS 2016-2017) - Rapport de synthèse",
        link: "/documents/EnquenteSanteDemographes/EDSB-III_Rapport-Synthese_Analyse-secondaire-2.pdf",
        description: "Malgré des progrès, des défis persistent : moins de 50% des femmes burundaises suivent les visites prénatales recommandées et d'importantes inégalités subsistent entre zones urbaines/rurales et niveaux socio-économiques dans l'accès aux soins maternels.",
        date: "2019-01-01"
    },
    {
        title: "Troisième enquête démographique et de santé au Burundi (EDSB-III) 2016-2017",
        link: "/documents/EnquenteSanteDemographes/EDSIII.pdf",
        description: "L'enquête nationale révèle des disparités dans l'accès aux services de base : 83% des ménages ont une source d'eau améliorée (mais 45% subissent des pénuries), 79% des enfants sont vaccinés, mais seulement 7% des femmes utilisent des méthodes contraceptives, avec des écarts importants entre zones urbaines et rurales.",
        date: "2017-12-01"
    },
    {
        title: "Enquête démographique et de santé Burundi 2010 - Rapport final",
        link: "/documents/EnquenteSanteDemographes/Burundi-EDS-2010-FINAL-REPORT.pdf",
        description: "L'EDSB-II (2010) révèle des défis majeurs : fécondité élevée (6,4 enfants/femme), faible utilisation effective de contraceptifs (13% malgré 97% de connaissance) et couverture prénatale insuffisante (33%), soulignant les besoins en santé materno-infantile au Burundi.",
        date: "2012-05-01"
    }
];

function EnquenteSanteDemographe() {
    const [showMoreHealth, setShowMoreHealth] = useState(false);
    const [showMoreDemography, setShowMoreDemography] = useState(false);
    const [healthYear, setHealthYear] = useState('');
    const [demographyYear, setDemographyYear] = useState('');
    const [allYears, setAllYears] = useState([]);
    const [activeTab, setActiveTab] = useState(0); 

    const handleShowMoreHealth = () => setShowMoreHealth(!showMoreHealth);
    const handleShowMoreDemography = () => setShowMoreDemography(!showMoreDemography);

    useEffect(() => {
        const healthYears = annuaires.map(item => new Date(item.date).getFullYear());
        const demographyYears = odd.map(item => new Date(item.date).getFullYear());
        const uniqueYears = [...new Set([...healthYears, ...demographyYears])].sort();
        setAllYears(uniqueYears);
    }, []);

    const filteredHealthReports = React.useMemo(() => {
        return healthYear
            ? annuaires.filter(annuaire => new Date(annuaire.date).getFullYear().toString() === healthYear)
            : annuaires;
    }, [healthYear]);

    const filteredDemographyReports = React.useMemo(() => {
        return demographyYear
            ? odd.filter(document => new Date(document.date).getFullYear().toString() === demographyYear)
            : odd;
    }, [demographyYear]);

    const handleChangeTab = (event, newValue) => {
        setActiveTab(newValue); 
    };

    return (
        <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '20px' }}>
            <NavigationBar />
             <Container maxWidth="lg" style={{ paddingTop: '54px' }}>
          
                <Tabs
                    value={activeTab}
                    onChange={handleChangeTab}
                    textColor="inherit"
                    indicatorColor="secondary"
                  
                >
                     <Tab label="Démographie" />
                    <Tab label="Santé" />
                   
                </Tabs>

                {/* Section Santé */}
                {activeTab === 1 && (
                    <>
                          <Divider style={{ margin: '20px 0' }} />

                        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                        Rapports des enquêtes: Santé
                        </Typography>
                        <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '20px' }}>
                            Découvrez les rapports récents sur la santé, qui évaluent l'impact de divers programmes et initiatives de santé publique au Burundi.
                        </Typography>
                        <FormControl variant="outlined" style={{ marginLeft: '0px', width: '300px',marginBottom:'20px' }}>
                            <Select
                                value={healthYear}
                                onChange={(e) => setHealthYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Toutes les années</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Grid container spacing={1}>
                            {filteredHealthReports.slice(0, showMoreHealth ? filteredHealthReports.length : 2).map((annuaire, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card elevation={3} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <Grid container>
                                            <Grid item xs={4}>
                                            <a href={annuaire.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                                                <img src="asset/cover/cover.jpg" alt="Cover" style={{ width: '100%', height: 'auto' }} />
                                                </a>
                                            </Grid>
                                         
                                            <Grid item xs={8}>
                                                <CardContent>
                                                    <Typography variant="body1" component="div" style={{ fontWeight: 'bold', color: '#2E7D32' }}>
                                                        <a href={annuaire.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                                                        {<DownloadIcon />} {annuaire.title}
                                                        </a>
                                                    </Typography>
                                                    <Typography variant="body2">{annuaire.description}</Typography>
                                                </CardContent>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        <Button onClick={handleShowMoreHealth}    style={{
                marginTop: '20px',
                marginBottom:'20px',
                backgroundColor: 'green',
                color: 'white',
              }}
            >
                            {showMoreHealth ? 'Voir moins de rapports' : 'Plus de rapports'}
                        </Button>
                    </>
                )}

                {activeTab === 0 && (
                    <>
                        <Divider style={{ margin: '20px 0' }} />
                        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#2E7D32' }}>
                        Rapports des enquêtes: Démographie
                        </Typography>
                        <Typography variant="body1" align="justify" paragraph style={{ marginBottom: '20px' }}>
                            Cette section présente des rapports sur les tendances démographiques et la santé, fournissant des données utiles pour les politiques publiques et les recherches.
                        </Typography>
                        <FormControl variant="outlined" style={{ marginLeft: '0px', width: '300px',marginBottom:'20px' }}>
                            <Select
                                value={demographyYear}
                                onChange={(e) => setDemographyYear(e.target.value)}
                                displayEmpty
                            >
                                <MenuItem value="">
                                    <em>Toutes les années</em>
                                </MenuItem>
                                {allYears.map(year => (
                                    <MenuItem key={year} value={year.toString()}>{year}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>

                        <Grid container spacing={1}>
                            {filteredDemographyReports.slice(0, showMoreDemography ? filteredDemographyReports.length : 2).map((document, index) => (
                                <Grid item xs={12} key={index}>
                                    <Card elevation={3} style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                        <Grid container>
                                     
                                            <Grid item xs={3}>
                                            <a href={document.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                                                <img src="asset/cover/cover.jpg" alt="Cover" style={{ width: '100%', height: 'auto' }} />
                                            </a>
                                            </Grid>
                                           
                                            <Grid item xs={9}>
                                                <CardContent>
                                                    <Typography variant="body1" component="div" style={{ fontWeight: 'bold', color: '#2E7D32' }}>
                                                        <a href={document.link} style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
                                                        {<DownloadIcon />}{document.title}
                                                        </a>
                                                    </Typography>
                                                    <Typography variant="body2">{document.description}</Typography>
                                                </CardContent>
                                            </Grid>
                                        </Grid>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                        <Button onClick={handleShowMoreDemography}  style={{
                marginTop: '20px',
                marginBottom:'20px',
                backgroundColor: 'green',
                color: 'white',
              }}
            >
                            {showMoreDemography ? 'Moins de rapports' : 'Plus de rapports'}
                        </Button>
                    </>
                )}
            </Container>
            <Footer />
        </div>
    );
}

export default EnquenteSanteDemographe;